
import { MovimentacaoClient } from '@/client/movimentacao.client';
import { Movimentacao } from '@/model/movimentacao';
import axios from 'axios';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HomeView',
  data() {
    return {
      formattedDate: '',
      movimentacoes: [] as Movimentacao[],
      moveOpen: [] as Movimentacao[],
      moveClose: [] as Movimentacao[],
      previousDayGain: 0 // Initialize previousDayGain with 0
    };
  },
  computed: {
    dayGain(): number {
      return this.moveClose.reduce((acc, movimentacao) => {
        return acc + movimentacao.valorTotal;
      }, 0);
    },
  },
  mounted() {
    const options = { weekday: 'long', day: 'numeric', month: 'long' };
    this.formattedDate = new Date().toLocaleString('en-US', options as Intl.DateTimeFormatOptions);
    this.fetchMovimentacoes();
    this.fetchMovimentacoesOpen();
    this.fetchMovimentacoesClose();
    this.retrievePreviousDayGain();
  },
  methods: {
    async fetchMovimentacoes() {
      try {
        const moveClient = new MovimentacaoClient();
        const response = await moveClient.findLastFive();
        this.movimentacoes = response;
      } catch (error) {
        console.error(error);
      }
    },

    async fetchMovimentacoesOpen() {
      try {
        const moveClient = new MovimentacaoClient();
        const response = await moveClient.findAllByOpen('');
        this.moveOpen = response;
      } catch (error) {
        console.error(error);
      }
    },

    async fetchMovimentacoesClose() {
      try {
        const moveClient = new MovimentacaoClient();
        const response = await moveClient.findAllByClose();
        this.moveClose = response;

        // Store dayGain in local storage with the current date
        const gainData = {
          date: this.formattedDate,
          gain: this.dayGain
        };

        const key = 'dayGain-' + this.formattedDate;  // Append date to the key name
        localStorage.setItem(key, JSON.stringify(gainData));
      } catch (error) {
        console.error(error);
      }
    },

    getActionRoute(movimentacao: Movimentacao) {
      if (movimentacao.saida) {
        return { path: '/access-closemovement', query: { licensePlate: movimentacao.veiculo.placa } }
      } else {
        return {
          path: '/access-movement',
          query: { licensePlate: movimentacao.veiculo.placa }
        }
      }
    },

    retrievePreviousDayGain() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1); // Get yesterday's date

      const options = { weekday: 'long', day: 'numeric', month: 'long' };
      const formattedYesterday = yesterday.toLocaleString('en-US', options as Intl.DateTimeFormatOptions);
      const key = 'dayGain-' + formattedYesterday;

      const previousDayData = localStorage.getItem(key);
      if (previousDayData) {
        const { gain } = JSON.parse(previousDayData);
        this.previousDayGain = gain;
      }


  },
}
});
